import Vue from 'vue';
import downLoadButton from '../components/element/downloadButton.vue';
import downloadProgress from '../components/element/downloadProgress.vue';
import { PACKAGE_SYNCER_MODES } from '../tools/consts';
import { getterTypes } from '../types';

const DownLoadButton = Vue.extend(downLoadButton);
const DownloadProgress = Vue.extend(downloadProgress);
export default {
	init() {
		if (
			this.$store.state.packageSyncer.isActive &&
			this.$store.state.packageSyncer.mode === PACKAGE_SYNCER_MODES.tour
		) {
			const $posts = [...this.$el.querySelectorAll('.post[data-url^="command://startTour"]')];

			$posts.forEach($post => {
				const id = $post
					.getAttribute('data-url')
					.trim()
					.split('=')[1];
				$post.setAttribute('sub-part-id', id);
				$posts.forEach($post => {
					$post.setAttribute(
						'sub-part-state',
						this.$store.getters[getterTypes.packageSyncerPartState]($post.getAttribute('sub-part-id'))
					);
				});
				const button = new DownLoadButton({
					store: this.$store,
					propsData: { subPartID: id },
				}).$mount();
				$post.appendChild(button.$el);

				const progress = new DownloadProgress({
					store: this.$store,
					propsData: { subPartID: id },
				}).$mount();
				$post.appendChild(progress.$el);
			});
		}
	},
};
